var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 5.848 12.908 12l6.592 6.152-.908.848L12 12.848 5.408 19l-.908-.848L11.092 12 4.5 5.848 5.408 5 12 11.152 18.592 5l.908.848Z",
    fill: "#141414"
  })));
};
export { SvgCross as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xOS41IDUuODQ3NjZMMTIuOTA4MiAxMkwxOS41IDE4LjE1MjNMMTguNTkxOCAxOUwxMiAxMi44NDc3TDUuNDA4MiAxOUw0LjUgMTguMTUyM0wxMS4wOTE4IDEyTDQuNSA1Ljg0NzY2TDUuNDA4MiA1TDEyIDExLjE1MjNMMTguNTkxOCA1TDE5LjUgNS44NDc2NloiIGZpbGw9IiMxNDE0MTQiLz4KPC9zdmc+Cg==";